import LoadingMask from './LoadingMask';
import './LoadingMask.scss';

export default LoadingMask;